/**
 * 越南语
 */
export default {
  route: {
    dashboard: {
      _name: 'Bảng điều khiển',
      workplace: {_name: 'Bàn làm việc'},
      analysis: {_name: 'Trang phân tích'},
      monitor: {_name: 'Trang giám sát'}
    },
    frontpage: {
      home: {_name: 'Trang chủ'},
      test: {_name: 'Gỡ lỗi API'},
    },
    system: {
      _name: 'Quản lý tài khoản',
      admin: {_name: 'Danh sách quản trị'},
      finance: {_name: 'Danh sách tài nguyên'},
      user: {_name: 'Danh sách người dùng'},
      acceptor: {_name: 'Danh sách chấp nhận'},
      menu: {_name: 'Quản lý menu'},
      tenantAdmin: {_name: 'Danh sách vận hành'},
      tenant: {_name: 'Danh sách vận hành'},
    },
    resource: {
      _name: 'Quản lý tài nguyên',
      class: {_name: 'Nhóm tài nguyên'},
      recolumn: {_name: 'Tài nguyên thu tiền'},
    },
    wallet: {
      _name: 'Cài đặt ví',
      walletlist: {_name: 'Danh sách ví'},
      currency: {_name: 'Quản lý tiền tệ'},
      fiatcurrency: {_name: 'Tiền pháp định'},
      virtualcurrency: {_name: 'Tiền ảo'},
      transmodel: {_name: 'Mô hình giao dịch'},
    },
    config: {
      _name: 'Cài đặt hệ thống',
      dictionary: {_name: 'Từ điển'},
      website: {_name: 'Tham số'},
      role: {_name: 'Quản lý vai trò'},
      errorlog: {_name: 'Bảo trì hệ thống'},
      countryregion: {_name: 'Quốc gia/Khu vực'},
      banks: {_name: 'Quản lý ngân hàng'},
      clientSimulator: {_name: 'Gỡ lỗi API'},
      shuju: {_name: 'Dọn dữ liệu'},
    },
    balance: {
      index: {_name: 'Số dư người dùng'},
    },
    channel: {
      _name: 'Quản lý kênh',
      type: {_name: 'Loại kênh'},
      uplist: {_name: 'Danh sách kênh'},
      dscolumn: {_name: 'Danh sách kênh (Thu)'},
      dfcolumn: {_name: 'Danh sách kênh (Chi)'},
      amount: {_name: 'Cài đặt preset'},
      records: {_name: 'Nhật ký preset'},
    },
    transaction: {
      _name: 'Quản lý giao dịch',
      inorder: {_name: 'Lệnh thanh toán'},
      inlist: {_name: 'Xác nhận thanh toán'},
      outorder: {_name: 'Lệnh rút tiền'},
      records: {_name: 'Biến động số dư'},
      verifyorder: {_name: 'Đơn xác nhận'},
      errorlog: {_name: 'Lỗi API merchant'},
      upstreamerrorlog: {_name: 'Lỗi API upstream'},
    },
    reconciliation: {
      _name: 'Quản lý đối chiếu',
      bussiness: {_name: 'Hóa đơn người dùng'},
      uplist: {_name: 'Hóa đơn upstream'},
      channel: {_name: 'Hóa đơn kênh'},
      shouyi: {_name: 'Doanh thu hệ thống'},
      bank: {_name: 'Hóa đơn tài nguyên'},
      bankrecords: {_name: 'Luồng thu tiền'},
    },
    exception: {
      _name: 'Trang lỗi',
      '403': {_name: '403'},
      '404': {_name: '404'},
      '500': {_name: '500'},
    },
    user: {
      _name: 'Cài đặt cá nhân',
      profile: {_name: 'Thông tin cá nhân'},
      message: {_name: 'Tin nhắn của tôi'},
    },
  },
  layout: {
    home: 'Trang chủ',
    header: {
      profile: 'Hồ sơ',
      password: 'Mật khẩu',
      logout: 'Đăng xuất',
    },
    footer: {
      website: 'Trang web',
      document: 'Tài liệu',
      authorization: 'Ủy quyền',
      copyright: 'Copyright © 2021',
    },
    logout: {
      title: 'Xác nhận',
      message: 'Bạn có chắc muốn đăng xuất không?',
    },
  },
  login: {
    title: 'Hệ thống Haila',
    username: 'Vui lòng nhập tài khoản',
    password: 'Vui lòng nhập mật khẩu',
    captcha: 'Vui lòng nhập mã xác nhận',
    remember: 'Nhớ mật khẩu',
    forget: 'Quên mật khẩu',
    login: 'Đăng nhập',
    loading: 'Đang đăng nhập',
    ipChecking: 'Đang xác minh IP truy cập…',
    ipDenied: 'IP hiện tại không có quyền truy cập',
    ipCheckFailed: 'Không thể xác minh IP, vui lòng kiểm tra mạng hoặc liên hệ quản trị viên',
    googleAuthenticator: 'Google Authenticator (nếu đã liên kết)',
  },
  universal: {
    startingtime: 'Thời gian bắt đầu',
    endtime: 'Thời gian kết thúc',
    pleasechoose: 'Vui lòng chọn',
    pleaseenter: 'Vui lòng nhập',
    recognize: 'Xác nhận',
    inquire: 'Truy vấn',
    reset: 'Đặt lại',
    export: 'Xuất',
    turnon: 'Bật',
    closure: 'Tắt',
    yes: 'Có',
    no: 'Không',
    unknown: 'Không rõ',
    success: 'Thành công',
    retreat: 'Hoàn tác',
    abnormal: 'Bất thường',
    cancel: 'Hủy',
  },
  home: {
    totalbalance: 'Tổng số dư',
    availablebalance: 'Số dư khả dụng',
    freezebalance: 'Số tiền đóng băng',
    unsettledamount: 'Số dư chưa thanh toán',
  },
  cleandata: {
    selecttime: 'Chọn thời gian',
    startingtime: 'Thời gian bắt đầu',
    endtime: 'Thời gian kết thúc',
    selectdata: 'Chọn dữ liệu',
    choose: 'Vui lòng chọn',
    option1: '[Tất cả dữ liệu] | Hãy lựa chọn cẩn thận, sau khi xóa sẽ không thể phục hồi được.',
    option2: '[Dữ liệu thanh toán] | Hãy lựa chọn cẩn thận, sau khi xóa sẽ không thể phục hồi được.',
    option3: '[Dữ liệu rút tiền] | Hãy lựa chọn cẩn thận, không thể khôi phục sau khi xóa.',
    option4: '[Dữ liệu thay đổi tài khoản] | Hãy lựa chọn cẩn thận, không thể khôi phục sau khi xóa.',
    warnings: 'Mẹo: Vui lòng xóa một cách thận trọng, không thể khôi phục sau khi thao tác.',
    recognize: 'Xác nhận dọn dẹp',
    confirmTitle: 'Xác nhận',
    confirmDelete: 'Xác nhận xóa',
  },
  maintenance: {
    errorLog: 'Nhật ký lỗi',
    paymentLog: 'Nhật ký debug',
    dataClean: 'Dọn dẹp dữ liệu',
    logTime: 'Thời gian',
    logFile: 'Tệp nhật ký',
    logContent: 'Nội dung',
    clearLog: 'Xóa nhật ký lỗi',
    clearPaymentLog: 'Xóa nhật ký debug',
    clearLogConfirm: 'Bạn có chắc muốn xóa tất cả nhật ký lỗi? Không thể khôi phục sau khi xóa.',
    clearPaymentLogConfirm: 'Bạn có chắc muốn xóa tất cả nhật ký debug? Không thể khôi phục sau khi xóa.',
  },
  orderlist: {
    username: 'Tên người dùng',
    userorder: 'Đơn hàng người dùng',
    systemorder: 'Đơn hàng hệ thống',
    transactiontype: 'Loại giao dịch',
    channelorder: 'Đơn hàng kênh',
    tradingstatus: 'Trạng thái giao dịch',
    transactionaccountchanges: 'Biến động giao dịch',
    selectionperiod: 'Chọn thời gian',
  },
  statistics: {
    today_success: '[Thành công hôm nay]:',
    today_receipt: '[Thu hôm nay]:',
    unknown_orders: ' [Đơn hàng không rõ]:',
    unknown_amount: ' [Số tiền không rõ]:',
    service_fee: ' [Phí dịch vụ]:',
    order_rate: ' [Tỷ lệ đơn hàng]:',
  },
};
